import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { LanguageService } from './language.service';


//Environment
const journalApiUrl = environment.journalApiUrl;
const appKey = environment.appKey;
const appVersion = environment.appVersion;
const deviceType = environment.deviceType;
declare var require: any;
// var jwt = require('angular2-jwt-simple');


@Injectable({
  providedIn: 'root'
})
export class GetService {
  cmpid = '';
  is_login = '';
  lang = 'en';
  private token: string;

  /**
   * Event type
   */
  public eventType = 'event_v3';

  /**
   * Session type
   */
  public sessionType = 'session_v3';

  constructor(public nls: LanguageService, private httpClient: HttpClient) {

    if (localStorage.getItem('lang') != null && localStorage.getItem('lang') != undefined && localStorage.getItem('lang') != 'null') {
      this.lang = localStorage.getItem('lang');
      this.getLanguageFile(this.lang).subscribe(data => {
        this.nls.languageText = JSON.parse(data);
        // console.log(this.nls.languageText)
      }, err => {
        //   console.log(err.error.text)

        // alert('error')
      })
    } else {
      this.getLanguageFile(this.lang).subscribe(data => {
        this.nls.languageText = JSON.parse(data);

      }, err => {
        //   console.log(err.error.text)

        // alert('error')
      })
    }
  }



  getContentShare(product_type, product_type_id, referal_id) {
    let header = { 'Authorization': appKey, lang: this.lang, ver: '4.0', appVersion: environment.appVersion, devicetype: environment.deviceType };
    let data = { 'product_type': product_type, 'referal_id': referal_id, 'product_type_id': product_type_id };

    return this.httpClient.get<any>(environment.apiUrl + '4.0/share-content-detail', {
      headers: header,
      params: data
    })
  }

  /**
   * Invoke API to get share product data.
   * @param product_type - Product Type -> eg - 41 for meeting.
   * @param product_type_id - Product Type Id -> ID where user has to be redirected to.
   * @param referal_id - Referral ID is the user referral ID.
   * @returns share product data. (fallback/default data).
   */
  getShareProductData(productType, productId, referal_id) {
    let header = { 'Authorization': appKey, lang: this.lang, ver: '4.3', appVersion: environment.appVersion, devicetype: environment.deviceType };
    let data = { 'product_type': productType, 'referal_id': referal_id, 'product_id': productId };

    return this.httpClient.get<any>(environment.apiUrl + '4.3/share-product-detail', {
      headers: header,
      params: data
    })
  }

  getProdDesc(id) {
    let header = { 'Authorization': appKey, lang: 'en', ver: '4.0', appVersion: environment.appVersion, devicetype: environment.deviceType };
    let data = { journal_id: id };

    return this.httpClient.get<any>(environment.apiUrl + '4.0/journal/description', {
      headers: header,
      params: data
    })
  }

  getProfileData(product_type_id) {

     let body =new HttpParams()
            .set('custom_id',product_type_id)
    let header={ 'Authorization': appKey, lang: this.lang, ver: '4.0', appVersion: environment.appVersion, devicetype: environment.deviceType};
    return this.httpClient.post(environment.apiUrl + '4.0/profile-summary',body,
    {
    headers:header
    });
  }






  // applogincheck(){


  //   return this.httpClient.get('https://app.docquity.com/detect/login-check.php', {responseType: 'text'});


  // }

  navigateToSection(product_type, product_id, eventProductType?) {

    if(product_type === 14){
      window.location.href = (environment.webUrl + '/#/webprofile/view/info/' + product_id);
    }
    product_id = Math.floor(product_id)

    switch (product_type) {

      case 1:
        {
          window.location.href = (environment.webUrl + "/#/web/list/" + product_id)
          break;
        }
      case 8:
        {
          window.location.href = (environment.webUrl + "/#/cme/detail/" + product_id)
          break;
        }
      case 7:
        {
          if ( eventProductType === this.eventType) {
            window.location.href = (environment.webUrl + '/#/eventv3/detail/' + product_id);
          } else {
            window.location.href = (environment.webUrl + '/#/event/detail/' + product_id);
          }
          break;
        }
      case 21:
        {
          if ( eventProductType === this.sessionType) {
            window.location.href = (environment.webUrl + '/#/eventv3/session/' + product_id);
          } else {
            window.location.href = (environment.webUrl + '/#/event/session-details/' + product_id);
          }
          break;
        }
      case 25:
        {
          window.location.href = (environment.webUrl + '#/survey/list/not-attempted');
          break;
        }
      case 3:
        {
          window.location.href = (environment.webUrl + '/#/clinical/detail/' + product_id);
          break;
        }
      case 24:
        {
          window.location.href = (environment.webUrl + '/#/doctalk/detail/' + product_id + '/24');
          break;
        }
      case 28:
        {
          window.location.href = (environment.webUrl + '/#/pharma/detail/' + product_id);
          break;
        }

      case 27:
        {
          window.location.href = (environment.webUrl + '/#/webinar/detail/' + product_id);
          break;
        }

      case 10:
        {
          window.location.href = (environment.webUrl + "/#/channel/detail/" + product_id)
          break;
        }


      case 15:
        {
          window.location.href = (environment.webUrl + "/#/pharma/drug/" + product_id)
          break;
        }

      case 36:
      {
        window.location.href = (environment.webUrl + '/#/doctalk/detail/' + product_id + '/36');
        break;
      }

      case 41:
        {
          window.location.href = (environment.webUrl + '/#/meeting/detail/' + product_id);
          break;
        }

    }
  }

  navigateToHome() {
    window.location.href = environment.webSiteUrl;
  }



  getLanguageFile(lang) {
    let dt = new Date();
    let url = 'assets/en.json' + '?time=' + dt.getTime();
    if (lang == 'in') {
      url = 'assets/id.json' + '?time=' + dt.getTime();
    }
    if (lang == 'vi') {
      url = 'assets/vi.json' + '?time=' + dt.getTime();
    }
    if (lang == 'zh') {
      url = 'assets/zh.json' + '?time=' + dt.getTime();
    }

    return this.httpClient.get(url, { responseType: 'text' });
  }

}
